import {
  Button,
  ButtonGroup,
  Container,
  HStack,
  IconButton,
  MenuButton,
  MenuItem,
  MenuList,
  Show,
  Text,
  ThemeTypings,
  Menu,
  useBreakpointValue,
  Flex,
  VStack,
} from "@chakra-ui/react";
import {
  ChevronDown,
  ExternalLink,
  Facebook,
  Instagram,
  Menu as MenuIcon,
} from "lucide-react";
import { RefAttributes, useState } from "react";
import { Link, LinkProps, Outlet } from "react-router-dom";
//import logotype from "./ofi-logga.png";
//import logotype from "./ofi-logga-medbakgrund.jpg";
import logotype from "./OFI-header.png";

import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { Role, useSessionState } from "./Session/SessionService";
import { LoginModal } from "./Session/LoginModal";
import { FakeLoginModal } from "./Session/FakeLoginModal";

const menuItems: {
  name: string;
  colorScheme: ThemeTypings["colorSchemes"];
  to?: LinkProps["to"];
  href?: string;
}[] = [
  {
    name: "Start",
    to: ".",
    colorScheme: "blue",
  },
  {
    name: "Medlemskap",
    to: "medlemskap",
    colorScheme: "blue",
  },
  {
    name: "Tävlingar",
    to: "tavlingar",
    colorScheme: "blue",
  },
  {
    name: "Sponsorer",
    to: "sponsorer",
    colorScheme: "blue",
  },
  {
    name: "Klubbshop",
    href: "https://www.tifosi.se/osthammarfriidrott",
    colorScheme: "blue",
  },
  { name: "Föreningen", to: "foreningen", colorScheme: "blue" },
];

export const Layout = () => {
  const [showLoginModal, setShowLoginModal] = useState(false);
  const [showImpersonateLoginModal, setShowImpersonateLoginModal] =
    useState(false);
  const session = useSessionState();
  const isMediumScreen = useBreakpointValue({
    base: false,
    sm: true,
    md: false,
  });

  const isMobile = useBreakpointValue({ base: true, sm: false });

  return (
    <>
      <ToastContainer style={{}} limit={5} />
      <Container maxW="container.lg" as="header" pt={4}>
        <HStack as="header" spacing={8}>
          <img src={logotype} alt="Östhammars Friidrott" />
        </HStack>
        <VStack position="absolute" top={0} right={0}>
          <Button
            variant={session.user ? "solid" : "ghost"}
            colorScheme="orange"
            onClick={() => {
              setShowLoginModal((prev) => !prev);
            }}
          >
            {(session.user && `${session.user} (${session.role})`) ||
              "Logga in"}
          </Button>
          <Button
            hidden={session?.role != Role.DEVELOPER}
            variant={session.user ? "solid" : "ghost"}
            colorScheme="red"
            onClick={() => {
              setShowImpersonateLoginModal((prev) => !prev);
            }}
          >
            "Byt användare"
          </Button>
        </VStack>
        <Show above="md">
          {showLoginModal && (
            <LoginModal
              onClose={() => {
                setShowLoginModal(false);
              }}
              fillScreen={false}
            />
          )}
          {showImpersonateLoginModal && (
            <FakeLoginModal
              onClose={() => {
                setShowImpersonateLoginModal(false);
              }}
              fillScreen={false}
            />
          )}
          <HStack py={8}>
            {menuItems.map((item) => {
              if (item.to) {
                return (
                  <Button
                    key={item.name}
                    to={item.to}
                    as={Link}
                    width={"fit-content"}
                    padding={"5px"}
                    colorScheme={item.colorScheme}
                  >
                    {item.name}
                  </Button>
                );
              } else if (item.href) {
                return (
                  <Button
                    key={item.name}
                    href={item.href}
                    as="a"
                    colorScheme={item.colorScheme}
                    rightIcon={<ExternalLink size={18} />}
                    width={"fit-content"}
                    padding={"5px"}
                  >
                    {item.name}
                  </Button>
                );
              }

              throw new Error("Missing to or href on menu item");
            })}
          </HStack>
        </Show>
        <Show below="md">
          {showLoginModal && (
            <LoginModal
              onClose={() => {
                setShowLoginModal(false);
              }}
              fillScreen={true}
            />
          )}
          {showImpersonateLoginModal && (
            <FakeLoginModal
              onClose={() => {
                setShowImpersonateLoginModal(false);
              }}
              fillScreen={false}
            />
          )}
          <Menu>
            <MenuButton
              my={4}
              as={Button}
              rightIcon={<ChevronDown />}
              w="100%"
              fontSize={{ base: "16px", sm: "24px" }}
            >
              Meny
            </MenuButton>
            <MenuList w="100%" right={0}>
              {menuItems.map((item) => {
                if (item.to) {
                  return (
                    <MenuItem key={item.name} to={item.to} as={Link}>
                      {item.name}
                    </MenuItem>
                  );
                } else if (item.href) {
                  return (
                    <MenuItem
                      key={item.name}
                      href={item.href}
                      as="a"
                      icon={<ExternalLink size={18} />}
                    >
                      {item.name}
                    </MenuItem>
                  );
                }

                throw new Error("Missing to or href on menu item");
              })}
            </MenuList>
          </Menu>
        </Show>
      </Container>

      <Container maxW="container.lg" as="main" flexGrow={1}>
        <Outlet />
      </Container>
      <Container maxW="container.lg" as="footer" py={6} display="flex">
        <Text flexGrow={1}>
          Copyright © 2022 osthammarfriidrott.se. Alla rättigheter reserverade.
        </Text>
        <ButtonGroup variant="link" spacing="3">
          <IconButton
            as="a"
            href="https://www.facebook.com/groups/150323241654930/"
            aria-label="Östhammar Friidrott på Facebook"
          >
            <Facebook />
          </IconButton>
          <IconButton
            as="a"
            href="https://www.instagram.com/osthammarfi/"
            aria-label="Östhammar Friidrott på Instagram"
          >
            <Instagram />
          </IconButton>
        </ButtonGroup>
      </Container>
    </>
  );
};
